import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { setLanguage } from "../../redux/slices/auth/authSlice"
import HeaderBurger from "./HeaderBurger"
import HeaderControls from "./HeaderControls"
import OverlayBurger from "./overlayBurger"
import LanguageSwitcher from "./LanguageSwitcher"
import "./Header.scss"

const Header = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const { isAuth, first_name, balance, loginType } = useAppSelector(
    (state) => state.auth,
  )
  const [isOpenMenu, setIsOpenMenu] = useState(false)

  return (
    <>
      <OverlayBurger isOpenMenu={isOpenMenu} setIsOpenMenu={setIsOpenMenu} />

      <header className="header py-sm-4 py-3">
        <div className="container header-container">
          <div className="header-inner">
            <div className="logo">
              <Link to="/"></Link>
              <img src="/vector/logo.svg" alt="logo" />
            </div>

            <div className="header-inner__right">
              {isAuth && (
                <HeaderControls balance={balance} first_name={first_name} />
              )}
              {!isAuth && (
                <Link
                  to="/login"
                  className="text-transform-none text-decoration-none"
                >
                  {t("buttons.logIn")}
                </Link>
              )}

              <LanguageSwitcher onChange={(code) => dispatch(setLanguage(code))} />
            </div>

            {isAuth && (
              <HeaderBurger
                isOpenMenu={isOpenMenu}
                setIsOpenMenu={setIsOpenMenu}
              />
            )}
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
